import React, { useState } from "react";
import SMSGreenTutor from "./SMSGreenTutor";
import SMSGreenStudent from "./SMSGreenStudent";



const SMSGreen = () => {
  const [activeTab, setActiveTab] = useState(0); // 0 is the index for the first tab

  const renderTabContent = () => {
    switch (activeTab) {
      case 0:
        return <SMSGreenTutor></SMSGreenTutor>;
      case 1:
        return <SMSGreenStudent></SMSGreenStudent>;
 
      default:
        return null;
    }
  };

  return (
    <div className="bg-green-100 h-screen">
      <div className="w-full h-20 flex justify-start pl-5 items-center bg-gree-100 shadow-md">
        <h2 className="text-xl text600 text-start text-green-900 font-montserrat">
          Sent SMS
        </h2>
      </div>
      <div className="m-5 flex flex-row gap-5">
        <button
          onClick={() => setActiveTab(0)}
          className={activeTab === 0 ? "bg-green-900 shadow-xl rounded font-montserrat text-lg px-6 text-white py-2" : "bg-green-600 text-white rounded font-montserrat text-lg px-6 py-2"}
        >
          Sent SMS for Tutor
        </button>
        <button
          onClick={() => setActiveTab(1)}
          className={activeTab === 1 ? "bg-green-900 shadow-xl rounded font-montserrat text-lg px-6 text-white py-2" : "bg-green-600 text-white rounded font-montserrat text-lg px-6 py-2"}
        >
          Sent SMS for Guardian
        </button>
  
      </div>
      <div>{renderTabContent()}</div>
    </div>
  );
};

export default SMSGreen;
